import { Dispatch } from 'redux';
import { doValidateByState } from '../../services/validation.service';
import { FormBaseStore } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import {
  SET_FORM_VALUE,
  setFormValueAction,
  FLIP_IS_SENDING_FLAG,
  flipIsSendingFlagAction,
} from './formModel.actionTypes';
import { thunkGetStateFunc } from '../store.provider';
import { setValidationResults } from './validationResults.action';
import { sendOrder } from '../../services/formModel.service';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import { dialogueError } from '../../Redux/Actions/errors.actions';
import { setSavingState } from './globals.actions';
import {
  getErrorBodyVipSPSessionTimeout,
  getErrorBodyJwtTokenTimeout,
  getErrorBodyApiErrorOnSend,
  getErrorBodyNoOfOrdersTodayReached,
} from 'sos-eservice-common/js/config/dialogueErrorBodies';

export function setFormValue(field: FormField<any>) {
  return function (dispatch: Dispatch, getState: thunkGetStateFunc<FormBaseStore<any>>) {
    dispatch({
      type: SET_FORM_VALUE,
      payload: field,
    } as setFormValueAction);
    dispatch(setSavingState(true));
    doValidateByState(getState()).then((validationResults) => {
      dispatch(setValidationResults(validationResults));
    });
    // If we save here, the autosave function will become obsolete
    //saveOrder(getState().formModel, getState().globals.orderId);
  };
}

export function flipIsSendingFlag() {
  return {
    type: FLIP_IS_SENDING_FLAG,
  } as flipIsSendingFlagAction;
}

export function saveFormOrder(onSuccess: () => any = null) {
  return function (dispatch: Dispatch, getState: thunkGetStateFunc<FormBaseStore<any>>) {
    const { globals, files, registers } = getState();
    dispatch(flipIsSendingFlag());
    return sendOrder(getState().formModel, registers, globals.orderId, files).then((result) => {
      dispatch(flipIsSendingFlag());
      if (result === 'LimitOfOrdersTodayReached') {
        dispatch(dialogueError(getErrorBodyNoOfOrdersTodayReached()));
      } else if (result instanceof ResponseError) {
        const error = result as ResponseError;
        if (error.body.detailCode) {
          switch (error.body.detailCode) {
            // SESSION ERROR
            case '401.1':
              // VIP (SP) SESSION TIMED OUT
              dispatch(dialogueError(getErrorBodyVipSPSessionTimeout(error.body.redirectUri)));
              break;
            case '401.2':
              // JWT TOKEN TIMED OUT
              dispatch(dialogueError(getErrorBodyJwtTokenTimeout(error.body.redirectUri)));
              break;
          }
        } else {
          switch (error.statusCode) {
            case 400:
              // API error
              dispatch(dialogueError(getErrorBodyApiErrorOnSend(error.body.errorMessage)));
              break;
            default:
              dispatch(dialogueError(getErrorBodyApiErrorOnSend(error.body.errorMessage)));
          }
        }
      } else if (Array.isArray(result)) {
        // kolla att result inneåller validation fel..
        if (result.length && result[0]['ValidationText']) {
          dispatch(setValidationResults(result));
          window.location.reload();
        }
      } else {
        // REDIRECT TO THANK YOU PAGE
        if (onSuccess !== null) {
          onSuccess();
        } else {
          window.location.href = globals.thankYouPageUrl;
        }
      }
    });
  };
}
